<template>
  <div>
    <el-empty description="敬请期待"></el-empty>
  </div>
</template>

<script>
export default {
  name: 'Software'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/software/Software.vue